module.exports = __webpack_public_path__ + "static/media/02-night-default.4b536636.png";